import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuditTrailState } from '../states/applet-audit-trail.states';

export const auditTrailFeatureKey = 'appletAuditTrail';

export const selectAuditTrailFeature = createFeatureSelector<AuditTrailState>(auditTrailFeatureKey);

export const selectAgGrid = createSelector(
    selectAuditTrailFeature,
    (state: AuditTrailState) => state.selectAgGrid
);

export const selectAuditTrail = createSelector(
    selectAuditTrailFeature,
    (state: AuditTrailState) =>state.selectAuditTrail
);
